import { render } from "./ExchangeSetting.vue?vue&type=template&id=19f676ff&scoped=true"
import script from "./ExchangeSetting.vue?vue&type=script&lang=js"
export * from "./ExchangeSetting.vue?vue&type=script&lang=js"

import "./ExchangeSetting.vue?vue&type=style&index=0&id=19f676ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f676ff"]])

export default __exports__